module.exports = __webpack_public_path__ + "static/media/thrive-onboarding.81756c24.png";